import yup from '../../../../helpers/yupInstance';
import type { TFunction } from 'i18next';

export function getAddExerciseLoadFormulaFormValidation(t: TFunction) {
  return yup.object({
    nameKey: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.nameKeyRequired')),
    value: yup
      .string()
      .max(4096, t('formikValidation.maxLength').replace('{0}', '4096'))
      .required(t('formikValidation.valueRequired')),
  });
}
